<div
  class="main-content d-flex flex-column"
  [class.pt-25]="isLogoShown"
  [class.gap-8]="isLogoShown"
  [class.has-audio-panel]="isAudioPanelShown"
  [class.has-idle-notice]="isIdleNoticeShown"
>
  @if (!isBlankPage) {
    <app-header></app-header>
  }
  @if (isLogoShown) {
    <div class="logo w-100 d-flex justify-content-center align-items-center">
      <div class="icon"></div>
      <div class="ms-10 fs-20 fw-semibold">Peech</div>
    </div>
  }
  <router-outlet></router-outlet>
  @if (!isBlankPage) {
    <div class="flex-grow-1"></div>
  }
  @if (!isBlankPage) {
    <app-footer></app-footer>
  }
  <!-- Unlike the chrome, the panel survives blank routes: audio keeps playing there
       (checkout, credits), and playback without a pause control is a trap. It renders
       nothing while idle, and sign-out stops the player itself. -->
  <app-audio-panel></app-audio-panel>
</div>
